import React, {Component} from 'react'
import MetadataListOfChoiceItemForm from "./metadatalistofchoiceitem.component.jsx"
import {FormattedMessage} from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx"

class MetadataListOfChoiceForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            list: this.props.value || []
        }
        this.deleteItem = this.deleteItem.bind(this)
        this.addItem = this.addItem.bind(this)
        this.changeItem = this.changeItem.bind(this)
    }

    componentDidMount() {
        this.setState({
            list: this.props.value || []
        })
    }

    deleteItem(index) {
        this.setState({
            list: this.state.list.filter((_, i) => i != index)
        }, () => {
            this.onChange()
        })
    }

    changeItem(index, value) {
        const list = this.state.list
        list[index] = value
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    addItem(e) {
        e.preventDefault()
        const list = this.state.list
        list.push('')
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    onChange() {
        const onChange = this.props.onChange || function () {}
        onChange(this.state.list)
    }

    render() {
        return (
            <div>
                {this.state.list.map((value, index) => {
                    return <MetadataListOfChoiceItemForm
                        key={'list-of-choice-' + index}
                        value={value}
                        index={index}
                        onDelete={this.deleteItem}
                        onChange={this.changeItem}
                    />
                })}
                <div className="row pt-2">
                    <div className="col-12">
                        <button className="btn btn-primary btn-sm" onClick={this.addItem}>
                            <Icon value={"plus-circle"}/>
                            <FormattedMessage
                                id="custom_field_definition.form.edit.add_choice_btn"
                                defaultMessage="Add a choice"
                            />
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}

export default MetadataListOfChoiceForm


// WEBPACK FOOTER //
// ./src/custom-field/form/metadatalistofchoice.component.jsx